
//スマホ時お知らせだったら左の要素見せない
// if(document.getElementById("barba")){
// 	const breakPoint = 1024;
// 	const topicsId = document.getElementById("in_topics");
// 	const hero_left = document.querySelector(".top-hero__left");
// 	if(topicsId && breakPoint > window.innerWidth) {
// 		hero_left.classList.add('tb-none');
// 	} else {
// 		hero_left.classList.remove('tb-none');
// 	}
// }


/*----------------------
// head内のタグを変更
------------------------*/
// function replaceHeadTags(target) {
// 	var $newPageHead = $('<head />').html($.parseHTML(target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true));
// 	var headTags = [
// 			"meta[name='keywords']",
// 			"meta[name='description']",
// 			"meta[property^='og']",
// 			"meta[property^='fb']",
// 			"meta[name^='twitter']",
// 			"meta[name='robots']",
// 			"meta[itemprop]",
// 			"link[itemprop]",
// 			"link[rel='prev']",
// 			"link[rel='next']",
// 			"link[rel='canonical']"
// 		].join(',');
// 	$('head').find(headTags).remove();
// 	$newPageHead.find(headTags).appendTo('head');
// }

/*------------------------
//Googleアナリティクスに送信
--------------------------*/
// var gaPush = function () {
// 	if (typeof ga === 'function') {
// 			ga('send', 'pageview', location.pathname);
// 	}
// 	if (typeof gtag === 'function') {
// 			gtag('config', 'トラッキングID', {'page_path': location.pathname});
// 	}
// }

// Barba.Dispatcher.on('initStateChange', function () {
// 	if (Barba.HistoryManager.history.length <= 1) {
// 			return;
// 	}
// 	if (typeof gtag === 'function') {
// 			// send statics by Google Analytics(gtag.js)
// 			gtag('config', 'YOUR_TRACKING_ID', {'page_path': location.pathname, 'use_amp_client_id': true});
// 	} else {
// 			// send statics by Google Analytics(analytics.js) or Google Tag Manager
// 			if (typeof ga === 'function') {
// 					var trackers = ga.getAll();
// 					trackers.forEach(function (tracker) {
// 							ga(tracker.get('name') + '.send', 'pageview', location.pathname, {'useAmpClientId': true});
// 					});
// 			}
// 	}
// });

/*-------------------------------------
// リンク先が現在と同じページの場合、リロードしない
---------------------------------------*/
// var $links = $('a[href]');
// var noLinkFunc = function (e) {
//     if (e.currentTarget.href === window.location.href) {
//         e.preventDefault();
//         e.stopPropagation();
//     }
// };

// $links.each(function (index, element) {
//     $(element).on('click', function (e) {
//         noLinkFunc(e);
//     });
// });

/*------------------------
barba起動
--------------------------*/

// let mask = document.querySelector(".mask");

// if(document.getElementById("barba")){
// 	barba.init({
// 		sync:true,
// 		transitions: [{
// 			async leave() {
// 				mask.classList.add('is-close');
// 				await new Promise((resolve) => {
// 					return setTimeout(resolve, 1000);
// 				});
// 			},
// 			beforeEnter: function (data) {
// 				replaceHeadTags(data.next);
// 				mask.classList.remove('is-close');
// 			},
// 			afterEnter() {
// 				mask.classList.remove('is-close');
// 			},
// 			// 次のページを表示する直前
// 		}]
// 	});
	
// 	barba.hooks.enter(() => {
// 		//スマホ時お知らせだったら左の要素見せない
// 		const breakPoint2 = 1024;
// 		const topicsId2 = document.getElementById("in_topics");
// 		const hero_left2 = document.querySelector(".top-hero__left");
// 		if(topicsId2 && breakPoint2 > window.innerWidth) {
// 			hero_left2.classList.add('tb-none');
// 		} else {
// 			hero_left2.classList.remove('tb-none');
// 		}

// 		//最上部に指定する
// 		window.scrollTo(0, 0);
// 	});
// }


